import React, {Component} from "react";

import Header from "../../Containers/Header/Header";
import Footer from "../../Containers/Footer";
import BaseBtn from "../../Buttons/BaseBtn";

import * as UserService from "../../../services/User/UserService";
import * as Utils from "../../Utils";
import Loading from "../../Containers/Loading";

class Profile extends Component {
    state = {
        // login form
        requestID: '',
        requestPW: '',//비밀번호',
        requestPWCheck: '',//'비밀번호 확인',
        requestName: '',//'이름',
        requestBirthday: '',//'년, 월, 일 순으로 총 8자리 ex.19000101',
        requestShcl: '',//'학교 이름',
        requestGradeList: [
            '-', '초1', '초2', '초3', '초4', '초5', '초6', '중1', '중2', '중3', '고1', '고2', '고3', '기타'
        ],
        requestGrade: null,
        requestParentsCallNum: '',//'숫자만 입력 ex.01012341234',
        requestProfileImg: null,
        requestCallNum: '',//'숫자만 입력 ex.01012341234',

        isPWTheSame: true,
        // loading
        isLoadingHide: false,

        user: null,
        isUpdate: false,
    };

    constructor() {
        super();
        this.studentFieldInfo = [
            {id: 0, name: '이름', type: 'text', value: 'requestName'},
            {id: 1, name: '생년월일', type: 'number', value: 'requestBirthday'},
            {id: 2, name: '학교', type: 'text', value: 'requestShcl'},
            {id: 3, name: '학년', type: 'option', value: 'requestGrade'},
            {id: 4, name: '*부모님 전화번호', type: 'number', value: 'requestParentsCallNum'}
        ];
        this.teacherFieldInfo = [
            {id: 0, name: '이름', type: 'text', value: 'requestName'},
            {id: 1, name: '생년월일', type: 'number', value: 'requestBirthday'},
            {id: 2, name: '*전화번호', type: 'number', value: 'requestCallNum'}
        ];
    }

    componentDidMount = () => {
        this.studentProfile = Utils.getIdentityFromCookie() == 'I_STUDENT';
        this.setState({
            isLoadingHide: true
        });

        UserService.userProfile().then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    const responseData = response.data.data;
                    this.setState({
                        user: responseData,
                        requestID: responseData.username,
                        requestName: responseData.name,
                        requestBirthday: responseData.birth,
                        requestShcl: responseData.school,
                        requestGrade: responseData.grade,
                        requestParentsCallNum: responseData.emergencyContactNum,
                        requestProfileImg: responseData.thumbnailImage,
                        requestCallNum: responseData.mobileNum
                    });
                } else {
                    console.log(response);
                    alert('ID를 불러오는데 실패했습니다.');
                }
            } else {
                console.log(response);
                alert('ID를 불러오는데 실패했습니다. 지속적으로 문제 발생시 문의해주세요.');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    };

    setProfileFieldInfo = () => {
        const fieldInfo = (this.studentProfile) ? this.studentFieldInfo : this.teacherFieldInfo;
        const list = fieldInfo.map(
            (item, i) => (
                (item.type == 'option') ?
                    this.setGradeOption(i) :
                    <li key={i}>
                         <span className="customInputBox">
                             <label htmlFor="requestParentsCallNum">
                                 <span>{item.name}</span>
                                 <input type={item.type}
                                        placeholder={this.state[item.value]} defaultValue={this.state[item.value]}
                                        onChange={this.handleChange} name={item.value}/>
                             </label>
                         </span>
                    </li>
            )
        );
        return list;
    }

    setGradeOption = (key) => {
        const {requestGrade} = this.state;
        return (
            <li key={key}>
                <span className="customInputBox">
                    <label htmlFor="requestGrade">
                        <span>학년</span>
                        <select name="requestGrade"
                                onChange={this.handleChange}
                                value={(requestGrade == null) ? '-' : requestGrade}>
                            {this.state.requestGradeList.map((grade, i) => {
                                return (
                                    <option key={i}> {grade} </option>
                                );
                            })}
                        </select>
                    </label>
                </span>
            </li>
        );
    }

    thumbnailChange = (e) => {
        if (!e.target.files[0].type.includes('image')) {
            alert('이미지 파일을 업로드 해주세요');
            return false;
        }
        const reader = new FileReader();
        const thumbnailImage = e.target.files[0];
        reader.readAsDataURL(thumbnailImage);
        const that = this;
        reader.onload = function () {
            that.setState({
                requestProfileImg: reader.result
            });
        }
    }

    userPasswordCheck = () => {
        if (this.state.requestPW == this.state.requestPWCheck) {
            this.setState({
                isPWTheSame: true
            });
        } else {
            this.setState({
                isPWTheSame: false
            });
        }
    }

    userValidation = () => {
        if (!this.state.isPWTheSame) {
            alert('비밀번호가 서로 다릅니다.')
            return false;
        }
        if (this.state.requestID == null || (this.state.requestID != null && this.state.requestID.trim() == '')
            || (this.state.requestID != null && this.state.requestID == '영문 또는 숫자만 입력')) {
            alert('아이디를 입력해 주세요.');
            return null;
            // return;
        }
        if (this.state.requestPW == null || (this.state.requestPW != null && this.state.requestPW.trim() == '')
            || (this.state.requestPW != null && this.state.requestPW == '비밀번호')) {
            alert('비밀번호를 입력해 주세요.');
            return false;
        }
        if (this.state.requestPWCheck == null || (this.state.requestPWCheck != null && this.state.requestPWCheck.trim() == '')
            || (this.state.requestPWCheck != null && this.state.requestPWCheck == '비밀번호 확인')) {
            alert('비밀번호를 입력해 주세요.');
            return false;
        }
        if (this.state.requestName == null || (this.state.requestName != null && this.state.requestName.trim() == '')
            || (this.state.requestName != null && this.state.requestName == '이름')) {
            alert('이릅을 입력해 주세요.');
            return false;
        }
        if (this.studentProfile) {
            if (this.state.requestParentsCallNum == null || (this.state.requestParentsCallNum != null && this.state.requestParentsCallNum.trim() == '')
                || (this.state.requestParentsCallNum != null && this.state.requestParentsCallNum == '숫자만 입력 ex.01012341234')) {
                alert('부모님 전화번호를 입력해 주세요.');
                return false;
            } else {
                const regexType = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
                if (!regexType.test(this.state.requestParentsCallNum)) {
                    alert('올바른 전화번호를 입력해 주세요.');
                    return false;
                }
            }
        } else {
            if (this.state.requestCallNum == null || (this.state.requestCallNum != null && this.state.requestCallNum.trim() == '')
                || (this.state.requestCallNum != null && this.state.requestCallNum == '숫자만 입력 ex.01012341234')) {
                alert('전화번호를 입력해 주세요.');
                return false;
            } else {
                const regexType = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
                if (!regexType.test(this.state.requestCallNum)) {
                    alert('올바른 전화번호를 입력해 주세요.');
                    return false;
                }
            }
        }
        if (this.state.requestBirthday != null && this.state.requestBirthday != '년, 월, 일 순으로 총 8자리 ex.19000101' && this.state.requestBirthday.trim() != '') {
            const regexType = /([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))/;
            if (!regexType.test(this.state.requestBirthday)) {
                alert('생년월일을 19001231 형식으로 입력해 주세요.');
                return false;
            }
        }
        return true;
    }

    onUpdate = () => {
        if (!this.userValidation()) {
            return false;
        }
        let userVO = {}
        if (!this.state.isStudentForm) {
            userVO = {
                'id': this.state.user.id,
                'username': this.state.requestID,
                'password': this.state.requestPW,
                'name': this.state.requestName,
                'birth': this.state.requestBirthday,
                'mobileNum': this.state.requestCallNum,
                'thumbnailImage': this.state.requestProfileImg,
                'identity': 'I_TEACHER'
            };
        } else {
            userVO = {
                'id': this.state.user.id,
                'username': this.state.requestID,
                'password': this.state.requestPW,
                'name': this.state.requestName,
                'birth': this.state.requestBirthday,
                'school': this.state.requestShcl,
                'grade': this.state.requestGrade,
                'emergencyContactNum': this.state.requestParentsCallNum,
                'thumbnailImage': this.state.requestProfileImg,
                'identity': 'I_STUDENT'
            };
        }

        UserService.updateStudent(userVO).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    alert('회원 정보 수정이 완료되었습니다.');
                    this.setState({isUpdate: true});
                } else {
                    console.log(response);
                    alert('회원 정보 수정을 실패 했습니다.');
                }
            } else {
                console.log(response);
                alert('회원 정보 수정을 실패 했습니다. 지속적으로 문제 발생시 문의해주세요.');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        const {
            requestID, requestPW, requestPWCheck, requestName, requestEngName, requestBirthday, requestShcl,
            requestGradeList, requestGrade, requestParentsCallNum, requestProfileImg,
            requestCallNum, requestPhonelNum, requestMail
        } = this.state;

        return (
            <div className="beaconWrapper">
                <Header isUpdate={this.state.isUpdate}/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <div className="pageContents">
                            <div className="profileFormWrapper">
                                <h3 className="screenOut">프로필</h3>
                                <div className="progileFormContents">
                                    <div className="formWrapper">
                                        <div className="imageWrapper">
                                            <div className="imageBox">
                                                <span className="image">
                                                    <img
                                                        src={(requestProfileImg !== null) ? requestProfileImg : "/images/common/img_profile.png"}
                                                        alt="profile"/>
                                                </span>
                                            </div>
                                            <div className="btnBox">
                                                <span className="customBtnBox">
                                                    <label htmlFor="requestProfileImg">
                                                        <span>사진 변경</span>
                                                    </label>
                                                    <input type="file"
                                                           onChange={this.thumbnailChange}
                                                           name="requestProfileImg"/>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="inputWrapper">
                                            <ul>
                                                <li>
                                                    <span className="customInputBox">
                                                        <label htmlFor="requestID">
                                                            <span className="userDuplicate">아이디</span>
                                                            <input type="text" defaultValue={requestID}
                                                                   readOnly={true}/>
                                                        </label>
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="customInputBox">
                                                        <label htmlFor="requestPW">
                                                            <span
                                                                className={this.state.isPWTheSame ? "userPassword" : "userPassword active"}>*비밀번호</span>
                                                            <input type="password"
                                                                   placeholder={(requestPW === '') ? '비밀번호' : requestPW}
                                                                   defaultValue={requestPW}
                                                                   onChange={this.handleChange}
                                                                   name="requestPW"/>
                                                        </label>
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="customInputBox">
                                                        <label htmlFor="requestPW">
                                                            <span
                                                                className={this.state.isPWTheSame ? "userPassword" : "userPassword active"}>*비밀번호 확인</span>
                                                            <input onBlur={() => this.userPasswordCheck()}
                                                                   type="password"
                                                                   placeholder={(requestPWCheck === '') ? '비밀번호 확인' : requestPWCheck}
                                                                   defaultValue={requestPWCheck}
                                                                   onChange={this.handleChange}
                                                                   name="requestPWCheck"/>
                                                        </label>
                                                    </span>
                                                </li>
                                                {this.setProfileFieldInfo()}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="btnWrapper">
                                        <BaseBtn btnColor={"deepPink"} btnName={"저장"} onClick={this.onUpdate}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Pages/Global/Profile.js